// extracted by mini-css-extract-plugin
module.exports = {"color":"GplHFn","oldColor":"x_HXFF","dropdown":"EHZqPm","oldDropdown":"sX06Sd","remainingColorsCounter":"FiuQ8z","colorPickerItemRemaining":"P8CghP"};